import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { FileThumbnail } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import * as env from 'config/env/env.config';

const FileMetadata = ({
  fileIconStyle,
  fileStatus,
  metaFileObj,
  metaFileFields,
  metaFileMapping,
}) => (
  <>
    {!isEmpty(metaFileObj) && (
      <>
        <hr className="border-dark-fill-blue" />
        <div className="space-y-2">
          {metaFileObj.map((fileField) => (
            <div className="flex" key={fileField.label}>
              <div className="pl-0 col-sm-3">
                <span className="font-heavy-font text-text-blue">{fileField.label}:</span>
              </div>
              <div className="pl-0 col-sm-9">
                {isEmpty(fileField.value) && fileStatus !== 'success' && <Spinner />}
                {fileField.value.map((fileObject) => (
                  <div className="flex col-sm-12" key={fileObject.id}>
                    <div className="mr-2">
                      <FileThumbnail style={fileIconStyle} contentType={fileObject.content_type} />
                    </div>
                    <a
                      href={`${env.CORE_BASE_URL}${fileObject.path}`} rel="noreferrer" target="_blank"
                      className="text-action-blue"
                    >
                      {fileObject.filename}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </>
    )}

    {/* Add Empty file types now -- if it is required and it is not in metaFileObj */}
    {isEmpty(metaFileObj) && !isEmpty(metaFileFields) &&
      metaFileFields.filter((fileObject) => get(fileObject, 'validations.required')).length !== 0 && (
        <hr className="border-dark-fill-blue" />
      )}
    {metaFileFields.filter((fileObject) => get(fileObject, 'validations.required') &&
      !Object.keys(metaFileMapping).includes(fileObject.label))
      .map((fileObject) => (
        <div className="flex" key={fileObject.label}>
          <div className="pl-0 col-sm-3">
            <span className="font-heavy-font text-text-blue ui-form-field__label--required">
              {fileObject.label}:
            </span>
          </div>
          <div className="pl-0 col-sm-9">
            <div className="flex col-sm-12">
              <div className="mr-2">
                <span className="text-red">Required</span>
              </div>
            </div>
          </div>
        </div>
      ))}
  </>
);

FileMetadata.propTypes = {
  fileIconStyle: PropTypes.object,
  fileStatus: PropTypes.string.isRequired,
  metaFileObj: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      content_type: PropTypes.string,
    })),
  })).isRequired,
  metaFileFields: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    validations: PropTypes.shape({
      required: PropTypes.bool,
    }),
  })).isRequired,
  metaFileMapping: PropTypes.object.isRequired,
};

FileMetadata.defaultProps = {
  fileIconStyle: {
    svg: {
      height: '18px',
      width: '14px',
      fill: '#4467AB',
    },
  },
};

export default FileMetadata;
